import "./App.css";
import { Route, Routes } from "react-router-dom";
import Menu from "./screens/menu/Menu";
import Home from "./screens/home/Home";
import ConfigProvider from "./context/config/ConfigProvider";
import DettaglioProdotto from "./screens/menu/detail/DettaglioProdotto";
import NotFound from "./screens/error/NotFound";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { useEffect } from "react";
import { ModalProvider } from "./context/ModalContext";
import CreaHamburger from "./screens/menu/detail/CreaHamburger";

function App() {
	useEffect(() => {
		CookieConsent.run({
			categories: {
				analytics: {
					enabled: true,
					readOnly: false,
				},
			},
			guiOptions: {
				consentModal: {
					layout: "cloud", // oppure "box"
					position: "bottom center",
					flipButtons: false
				},
				preferencesModal: {
					layout: "box",
					position: "center"
				}
			},

			onConsent: ({ cookie }) => {
				if (cookie.categories) {
					const analyticsEnabled = cookie.categories.find((category) => {
						return category === "analytics";
					});

					if (analyticsEnabled) {
						window.dataLayer = window?.dataLayer || [];
						function gtag() {
							if (window?.dataLayer) {
								window?.dataLayer.push(arguments);
							}
						}
						gtag("js", new Date());
						gtag("config", "G-T3S8FW7P2S");
					}
				}
			},

			cookie: {
				delay: 1500 // in ms
			},

			language: {
				default: "it",
				translations: {
					it: {
						consentModal: {
							title: "🍪 Usiamo i cookie",
							description: "Miglioriamo la tua esperienza con i cookie. Alcuni sono essenziali, altri ci aiutano a capire cosa ti piace.",
							acceptAllBtn: "Accetta tutti",
							acceptNecessaryBtn: "Solo essenziali",
							showPreferencesBtn: "Impostazioni",
						},
						preferencesModal: {
							title: "Preferenze Cookie",
							acceptAllBtn: "Accetta tutti",
							savePreferencesBtn: "Salva scelte",
							sections: [
								{
									title: "Google Analytics",
									description: "Utilizziamo cookie per analizzare il traffico e migliorare la tua esperienza.",
									linkedCategory: "analytics",
								},
								{
									title: "Ulteriori informazioni",
									description: 'Leggi la nostra <a href="/cookie-policy.pdf" download>Cookie Policy</a>.',
								},
							]
						}
					},
				},
			},
		});
		document.documentElement.classList.add('cc--darkmode');
	}, []);

	useEffect(() => {
		const setAppHeight = () => {
			const vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--app-height', `${vh * 100}px`);
		};

		setAppHeight();
		window.addEventListener('resize', setAppHeight);
		return () => window.removeEventListener('resize', setAppHeight);
	}, []);


	return (
		<ConfigProvider>
			<ModalProvider>
				<div className="app">
					<div className="pattern"></div>
					<Routes>
						<Route
							path="/"
							element={<Home />}
						/>
						<Route
							path="menu"
							element={<Menu />}
						/>
						<Route
							path="ordina/"
							element={<Menu />}
						/>
						<Route
							path="menu/:id"
							element={<DettaglioProdotto />}
						/>
						<Route
							path="crea/hamburger"
							element={<CreaHamburger />}
						/>
						<Route
							path="ordina/:id"
							element={<DettaglioProdotto />}
						/>
						<Route
							path="*"
							element={<NotFound />}
						/>
					</Routes>
				</div>
			</ModalProvider>
		</ConfigProvider>
	);
}

export default App;
